import { render, staticRenderFns } from "./DefaultTemplateMessage.vue?vue&type=template&id=57f5ebe2&scoped=true"
import script from "./DefaultTemplateMessage.vue?vue&type=script&lang=js"
export * from "./DefaultTemplateMessage.vue?vue&type=script&lang=js"
import style0 from "./DefaultTemplateMessage.vue?vue&type=style&index=0&id=57f5ebe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f5ebe2",
  null
  
)

export default component.exports